import { LOS, ROADWAY_FEATURE_VALUES, VC } from '../constants/auto'
import { NO, YES } from '../constants/roadwayVariables'

export const autoConfig = [
  {
    name: 'Capacity Assumption (Vehicles per Hour per Lane)',
    id: 'capacity_assumption',
    inputType: 'number',
    required: true,
    scores: [],
    notes:
      'The default value is 1600. In some instances, where a saturation flow rate analysis demonstrates a different throughput, it may be appropriate to modify this default.'
  },
  {
    name: 'Peak Hour Factor (%)',
    id: 'peak_hour_factor',
    inputType: 'number',
    required: true,
    scores: [],
    notes: 'The default value is 10%.',
    inputProps: { min: 0, max: 100 }
  },
  {
    name: 'Lane Repurposing Planned',
    id: 'lane_repurposing_planned',
    inputType: 'dropDown',
    required: true,
    scores: null,
    inputValues: [YES, NO],
    notes:
      'Is one or more lane on this roadway being considered for repurposing?'
  },
  {
    name: 'Roadway Features',
    id: 'roadway_features',
    inputType: 'checkBox',
    required: true,
    scores: null,
    inputValues: ROADWAY_FEATURE_VALUES,
    notes: 'Leave unchecked if not applicable.'
  },
  {
    name: 'Volume/Capacity Ratio',
    id: VC,
    inputType: 'number',
    required: true,
    scores: '',
    autoPopulated: true,
    notes:
      'Volume/capacity ratio, or V/C, is a ratio of how much available space on the road is currently being used by vehicles.'
  },
  {
    name: 'Level of Service',
    id: LOS,
    inputType: 'string',
    required: true,
    scores: null,
    notes:
      'Level of service, or LOS, is a measurement of traffic flow and how much delay is occurring on the road.',
    autoPopulated: true
  },
  {
    name: 'Auto Tier',
    id: 'tier',
    inputType: 'string',
    required: true,
    scores: null,
    notes: 'Value populated in project setup on previous page.',
    autoPopulated: true
  },
  {
    name: 'Land Use Context',
    id: 'land_use_context',
    inputType: 'string',
    required: true,
    scores: null,
    notes: 'Value populated in project setup on previous page.',
    autoPopulated: true
  }
]
